export default __webpack_public_path__ + "static/media/flood.4dd3030a.png";